
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Award } from 'lucide-react';
import { Button } from '@/components/ui/button';
import BadgeCard from '@/components/BadgeCard';
import { UserProgress } from '@/types/user';
import { Badge, getBadges, getUnlockedBadges } from '@/utils/gamification';

interface BadgesTabProps {
  userProgress: UserProgress;
}

const BadgesTab: React.FC<BadgesTabProps> = ({ userProgress }) => {
  // Get user badges
  const allBadges = getBadges(userProgress);
  const unlockedBadges = getUnlockedBadges(allBadges);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Badges</CardTitle>
        <CardDescription>
          Badges you've earned on your hormone health journey
        </CardDescription>
      </CardHeader>
      <CardContent>
        {unlockedBadges.length > 0 ? (
          <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {unlockedBadges.map(badge => (
                <BadgeCard
                  key={badge.id}
                  badge={badge}
                  showProgress={false}
                />
              ))}
            </div>
            
            <div className="mt-6 flex justify-center">
              <Button
                onClick={() => window.location.href = '/badges'}
                className="bg-hormony-coral hover:bg-hormony-dark-coral text-white"
              >
                <Award size={16} className="mr-2" />
                View All Badges
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center py-10">
            <Award size={32} className="mx-auto text-muted-foreground mb-3" />
            <h3 className="text-lg font-medium mb-2">No Badges Yet</h3>
            <p className="text-muted-foreground mb-4">
              Complete days in the program to start earning badges!
            </p>
            <Button
              onClick={() => window.location.href = '/badges'}
              variant="outline"
            >
              See Available Badges
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BadgesTab;
